// Enum definitions for vendor priority and order tracking
export enum ShipVendor {
    UNKNOWN = -1,
    PATHTEC = 0,
    DS2 = 1,
    THERAPAK = 2
}

export enum PhlebotVendor {
    ExamOne = 0,
    DS2 = 1
}

export enum NkrEntityType {
    DASH = 0,
    HOME_BLOOD_DRAW = 1,
    CRYO = 2,
    DONOR = 3,
    STREAMLINED_SEROLOGY = 4,
    RECIPIENT = 5,
    COVID_KIT_ORDER = 6,
    DONOR_CHEEK_SWAB_ORDER = 7,
    RECP_CHEEK_SWAB_ORDER = 8,
    ANTIBODY_SCREENING = 9,
    XM_TRACKING = 10,
    SEROLOGY_TRACKING = 11,
    PATIENT_INTAKE = 12,
    CENTER_BULK_CHEEK_SWAB = 13,
    STRONG_BOX = 14
}

export enum VendorType {
    KIT = 0,
    PHLEBOT = 1
}